import cn from '@core/utils/class-names';

interface FormGroupProps {
  title: React.ReactNode;
  className?: string;
  description?: string;
  children?: React.ReactNode;
}

export default function FormGroup({
  title,
  className,
  description,
  children,
}: FormGroupProps) {
  return (
<div className={cn('flex flex-col md:grid md:grid-cols-12 gap-5', className)}>
  <div className="col-span  -full sm:col-span-4">
    <h4 className="text-base font-medium">{title}</h4>
    {description && <p className="mt-2">{description}</p>}
  </div>
  {children && (
    <div className="col-span-full sm:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
      {children}
    </div>
  )}
</div>

  );
}
